// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import { _ } from "lodash"
import "./hacks/preline_overlay_collection"
import "preline/dist/preline.js"
import TurboPower from 'turbo_power'
import "./controllers"
import Stoked from "./stoked"

TurboPower.initialize(Turbo.StreamActions)
window.Stoked = Stoked

// Preline v3: a single autoInit re-initializes every registered component.
// Idempotent — it skips already-initialized elements.
const initPreline = () => window.HSStaticMethods.autoInit()

document.addEventListener("turbo:load", initPreline)
document.addEventListener("turbo:frame-load", initPreline)

// Turbo Stream replacements (e.g. replacing a filter bar that contains Preline
// dropdowns) don't fire turbo:load, so re-init Preline after each stream renders.
// autoInit is idempotent — it skips already-initialized elements.
document.addEventListener("turbo:before-stream-render", (event) => {
  const originalRender = event.detail.render
  event.detail.render = async (streamElement) => {
    await originalRender(streamElement)
    initPreline()
  }
})

Turbo.config.forms.mode = "optin"

window._ = _

import "./consent"
import "./strip_tracking_params"
import "./custom_turbo_stream_actions"
import "./turbo_confirm"
import "./turbo_form_submissions"
import "./hacks/charts"
import "./hacks/get_form_submission"
import "./service_worker_registration"
